import {Route, Routes, Outlet, Navigate} from 'react-router-dom';
import CustomerPage from './page/CustomerPage';


const CustomerRoutes = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          element={
            <>
              <CustomerPage />
            </>
          }
        />
      </Route>
      <Route index element={<CustomerPage />} />
    </Routes>
  );
};

export default CustomerRoutes;
